import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Main from "./Pages/Main";
import Story from "./Pages/Story";
import Tickets from "./Pages/Tickets";
import Merch from "./Pages/Merch";
import CheckoutSuccess from "./Pages/CheckoutSuccess";
import CheckoutFailure from "./Pages/CheckoutFailure";
import Game from "./Pages/Game";
import Garden from "./Pages/Garden";
import Info from "./Pages/Info";
import MusicPlayer from "./Pages/MusicPlayer";

import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" index element={<Main />} />
        <Route path="story" element={<Story />} />
        <Route path="shop" element={<Merch />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="game" element={<Game />} />
        <Route path="garden" element={<Garden />} />
        <Route path="info" element={<Info />} />
        {/*<Route path="music-player" element={<MusicPlayer />} />*/}
        <Route path="checkout_success" element={<CheckoutSuccess />} />
        <Route path="checkout_failure" element={<CheckoutFailure />} />
        <Route path="*" index element={<Main />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
